import { createContext, ReactNode, useContext, useState } from "react"

type AuthContextType = {
    token: string | null
    login: (token: string) => void
    logout: () => void
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
    const [token, setToken] = useState<string | null>(
        () => localStorage.getItem("access_token")
    )

    const login = (token: string) => {
        localStorage.setItem("access_token", token)
        setToken(token)
    }

    const logout = () => {
        localStorage.removeItem("access_token")
        setToken(null)
    }

    return (
        <AuthContext.Provider value={{ token, login, logout }}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuthContext() {
    const ctx = useContext(AuthContext)
    if (!ctx) {
        throw new Error("useAuthContext must be used inside AuthProvider")
    }
    return ctx
}